export enum AboutUsTabEnums {
  mobile = 'mobile',
  landing = 'landing'
}
